import * as Yup from "yup";
const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/png"];
const FILE_SIZE = 5072 * 2048;

export const initialSignUpValues = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  dob: "",
  profilePicture: "",
  password: "",
  confirm_password: "",
};

export const SignupSchema = Yup.object().shape({
  firstName: Yup.string().required("First name is a required field"),
  lastName: Yup.string().required("Last name is a required field"),
  dob: Yup.string().required("Date of Birth is a required field"),
  profilePicture: Yup.lazy((value) => {
    if (value) {
      switch (typeof value) {
        case "string":
          return Yup.mixed().test("url", (value) => value && value.includes("http")); // schema for image url
        case "object":
          return Yup.mixed()
            .test("fileFormat", "Unsupported Image Format", (value) => value && SUPPORTED_FORMATS.includes(value.type))
            .test("fileSize", "File is too large", (value) => value && value.size <= FILE_SIZE); // schema for image file
        default:
          return Yup.mixed().test("url", (value) => value && value.includes("http")); // here you can decide what is the default
      }
    } else {
      return Yup.string().notRequired();
    }
  }),
  email: Yup.string().email("Invalid email format").trim().required("Email is a required field"),
  phoneNumber: Yup.number().typeError("Only digit(s) is allowed").required("Phone number is a required field"),
  password: Yup.string().required("Password is required").min(8, "minimum of 8 characters"),
  confirm_password: Yup.string().oneOf([Yup.ref("password"), null], "Passwords must match"),
});

export const initialSigninValues = {
  email: "",
  password: "",
};

export const signinSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email format").trim().required("Email is a required field"),
  password: Yup.string().required("Password is required").min(8, "minimum of 8 characters"),
});
